define('drops/imageKpi/imageKpi',[
    'jquery',
    'lq',
    'lq/drop',
    'lq/style',
    'lq/util',
    'underscore'
], function ($, lq, Drop, Style, util, _) {
    'use strict';

    function ImageKpi(options) {
        Drop.call(this, $('<div/>'), options);
        var self = this;

        self.data.eventing = util.convertListOfKeyValuesToObject(self.data.eventing);

        self.value = 0;
        self.images = [];

        self.$element
	        .addClass('boxToBorderSize')
            .css({
                overflow: 'hidden'
            });

        self.$image = $('<img />')
            .hide()
            .appendTo(self.$element);

        Style.renderStyles(self);
    };

    Drop.extend(ImageKpi, Drop);

    ImageKpi.typeName = 'ImageKpi';

    ImageKpi.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.applyPosition();
        this.loadImages();
    };

    ImageKpi.prototype.loadImages = function () {
        var self = this;
        _.forEach(this.data.images, function (image) {
            var url = lq.getTenantUploads(image.fileName);

            $('<img/>')
                .on('load', function () {
                    loadingFunc(this, url, image.fileName, image.to, image.from);
                })
                .attr('src', url);
        });
        if (this.data.nullImage) {
            var url = lq.getTenantUploads(this.data.nullImage);

            $('<img/>')
                .on('load', function () {
                    loadingFunc(this, url, self.data.nullImage, null, null);
                })
                .attr('src', url);
        }

        var loadingFunc = function ($img, url, fileName, to, from) {
            var kpi = {};
            kpi.url = url;
            kpi.fileName = fileName;
            kpi.width = $img.width;
            kpi.height = $img.height;
            kpi.to = to;
            kpi.from = from;

            self.images.push(kpi);

            if (self.isTheImageWereLookingFor(kpi)) {
                self.replaceImage(kpi);
            }
        };
    };

    ImageKpi.prototype.updateImage = function () {
        var self = this;
        var selectedImage = _.find(this.images, function (image) {
            return self.isTheImageWereLookingFor(image);
        });
        this.replaceImage(selectedImage);
    };

    ImageKpi.prototype.isTheImageWereLookingFor = function (image) { // Because 'this.value' and 'image.from' can be null
        return this.value >= image.from && this.value < image.to || this.value === image.from;
    };

    ImageKpi.prototype.replaceImage = function (image) {
        if (!image) {
            this.$image.attr('src', '');
        } else if (image.url !== this.$image.attr('src')) {
            if (image.resizeOption === 'FillKeepRatio') {
                var aspectRatio = image.width / image.height;
                var availableWidth = this.$element.width();
                var availableHeight = this.$element.height();
                var targetWidth = availableWidth;
                var targetHeight = availableWidth / aspectRatio;

                if (targetHeight < availableHeight) {
                    targetWidth = availableHeight * aspectRatio;
                    targetHeight = availableHeight;
                }

                this.$image
                    .width(targetWidth)
                    .height(targetHeight);
            } else {
                this.$image
                    .width(this.$element.width())
                    .height(this.$element.height());
            }

            this.$image
                .attr('src', image.url)
                .show();
        }
    };

    ImageKpi.prototype.clearValue = function () {
        this.value = null;
        this.updateImage();
    };

    ImageKpi.prototype.setValue = function (update) {
        this.value = parseFloat(update.value);
        this.updateImage();
    };

    return ImageKpi;
});
